import Alerts from '@rover/utilities/Alerts';
import { redirect } from '@rover/utilities/url';

import $ from '@rover/globals/jquery';
import Backbone from '@rover/globals/backbone';
import dataLayer from '@rover/globals/dataLayer';

/**
 * Handles the favorite action for any sitter favorite button
 * clicked on in the document.
 */
export default Backbone.View.extend({
  el: document,
  activeClass: 'favorited',
  animationClass: 'favoriting',
  urlAttr: 'data-relationship-detail-url',
  events: {
    'click .js-favorite-button': 'handleFavoriteClick',
  },
  defaults: {
    isAnonymous: null,
    loginUrl: null, // url to redirect anonymous user to after login
    source: null, // string to identify the page that the favorite happened on for analytics
  },
  initialize(options) {
    this.options = options;
  },
  handleFavoriteClick(e) {
    e.stopPropagation();
    e.preventDefault();
    const $favBtn = $(e.currentTarget);
    this.updateFavoriteStatusOrAuthenticate($favBtn);
  },
  updateFavoriteStatusOrAuthenticate($btn) {
    if (this.options.isAnonymous) {
      redirect(this.options.loginUrl);
    } else {
      this.updateFavoriteStatus($btn);
    }
  },
  updateFavoriteStatus($btn) {
    const url = this.getFavoriteUrl($btn);
    const isFavoriteIntent = this.isFavoriteIntent($btn);
    const self = this;

    // GTM Save To Favorites Event
    if (isFavoriteIntent) {
      dataLayer.push({
        event: 'owner-conversion-sitter-profile-save-to-favorites',
      });
    } else {
      dataLayer.push({
        event: 'owner-conversion-sitter-profile-remove-from-favorites',
      });
    }

    const request = $.ajax({
      url,
      type: 'PUT',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ is_favorite: isFavoriteIntent }),
    });

    const errorCallback = response => {
      self.errorCallback(response, $btn, isFavoriteIntent);
    };

    const successCallback = response => {
      self.successCallback(response, isFavoriteIntent);
    };

    request.fail(errorCallback);
    request.done(successCallback);

    // Optimistically Update UI
    this.setButtonState($btn, isFavoriteIntent);
  },
  errorCallback(response, $btn, isFavoriteIntent) {
    this.setButtonState($btn, !isFavoriteIntent);
    Alerts.showAlert('saving this sitter');
  },
  successCallback(response, isFavoriteIntent) {
    if (isFavoriteIntent) {
      dataLayer.push({ event: `${this.options.source}-service-favorited` });
    } else {
      dataLayer.push({ event: `${this.options.source}-service-unfavorited` });
    }
  },
  setButtonState($btn, isFavoriteIntent) {
    const $btns = this.getAllProviderButtons($btn);
    $btns
      .toggleClass(this.activeClass, isFavoriteIntent)
      .toggleClass(this.animationClass, isFavoriteIntent);
  },
  isFavoriteIntent($btn) {
    return !$btn.hasClass(this.activeClass);
  },
  getFavoriteUrl($btn) {
    return $btn.attr(this.urlAttr);
  },
  getAllProviderButtons($btn) {
    const contactUrl = $btn.attr(this.urlAttr);
    const btnSelectorStr = `[${this.urlAttr}="${contactUrl}"]`;
    return this.$('.js-favorite-button').filter(btnSelectorStr);
  },
});



// WEBPACK FOOTER //
// ./js/pages/favorite_toggle_channel.js